var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11853_3534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64945 2.25003L16.7939 14.625C16.8598 14.739 16.8944 14.8684 16.8944 15C16.8944 15.1317 16.8598 15.261 16.794 15.375C16.7281 15.489 16.6335 15.5837 16.5194 15.6495C16.4054 15.7154 16.2761 15.75 16.1444 15.75H1.85545C1.7238 15.75 1.59447 15.7154 1.48046 15.6495C1.36644 15.5837 1.27177 15.489 1.20594 15.375C1.14012 15.261 1.10547 15.1317 1.10547 15C1.10547 14.8684 1.14012 14.739 1.20595 14.625L8.35045 2.25003C8.41628 2.13602 8.51095 2.04135 8.62497 1.97553C8.73898 1.90971 8.8683 1.87506 8.99995 1.87506C9.13159 1.87506 9.26092 1.90971 9.37493 1.97553C9.48894 2.04135 9.58362 2.13602 9.64945 2.25003ZM8.24995 12V13.5H9.74995V12H8.24995ZM8.24995 6.75003V10.5H9.74995V6.75003H8.24995Z",
    fill: "#FBC02D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11853_3534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.035bac9ead8de49fccff9472f4d1f18a.svg";
export { ForwardRef as ReactComponent };